export const VIMEO_URL = 'https://player.vimeo.com/video/';
export const ADDITIONAL_RESOURCES_URL = 'https://drive.google.com/drive/folders/1cxET-wG5NkLoldnhO3L4tZ2kYTp7ifd5?usp=sharing';
